import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import OverlineText from '../OverlineText/index.js';
import Text from '../Text/index.js';
import { jsx as _jsx } from "react/jsx-runtime";
const supportedSizes = [100, 200, 300, 400, 500, 600, 700];
const getSize = size => {
  if (!supportedSizes.includes(size) || size === 100) {
    return null;
  }
  if (size <= 400) {
    return size;
  }
  return {
    xs: size - 100,
    sm: size
  };
};

/**
 *  The Heading component takes children and wraps them in a container which utilizes the responsive text classNames
 *
 */
function Heading(_ref) {
  let {
    size = [...supportedSizes].pop(),
    children,
    componentClass = 'div',
    className,
    level,
    ...rest
  } = _ref;
  if (level) {
    return /*#__PURE__*/React.createElement(componentClass, {
      className: clsx(`heading-${level}`, className),
      'data-cmp': 'heading',
      ...rest
    }, children);
  }
  const Component = size === 200 ? OverlineText : Text;
  return /*#__PURE__*/_jsx(Component, {
    "data-cmp": "heading",
    size: getSize(parseInt(size, 10)),
    weight: size > 100 ? 'ultra-bold' : null,
    componentClass: componentClass,
    className: className,
    ...rest,
    children: children
  });
}
export default Heading;